import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';

import Alert from 'UiKit/alert';

import Head from './section/head';
import Filter from './section/filter';
import FormUpsert from './section/form-upsert';
import Table from './section/table';
import StudioProvider, { useStudioState } from './state';
import useResetAllState from './hooks/useResetAllState';

import styles from './styles.module.css';

const Studio = () => {
  const { state } = useStudioState();
  const onResetAllState = useResetAllState();

  useEffect(() => onResetAllState(), /* eslint-disable */ []);

  return (
    <Box className={styles['studio__container']}>
      <Head />
      <Filter />
      <Alert {...state?.alertProps} />
      <Table />

      <FormUpsert />
    </Box>
  );
};

const StudioContainer = () => <StudioProvider children={<Studio />} />;

export default StudioContainer;
